/**
 * Adres formatını düzenleyerek adres adı ve detay adres olarak ayırır
 */

export const formatAddress = (fullAddress) => {
  if (!fullAddress) return { name: '', detail: '' };
  
  // Yaygın adres adları ve işaretleri
  const addressMarkers = [
    'Hotel', 'Otel', 'Hastane', 'Hastanesi', 'Havalimanı', 'Airport',
    'AVM', 'Mall', 'Plaza', 'Clinic', 'Klinik', 'Üniversite', 'University',
    'Metro', 'İstasyon', 'Station', 'Merkez', 'Center', 'Meydanı', 'Meydan',
    'İskele', 'Sahil', 'Beach', 'Park', 'Müze', 'Museum'
  ];
  
  // Virgül ile böl
  const parts = fullAddress.split(',');
  
  if (parts.length >= 2) {
    const firstPart = parts[0].trim();
    const restParts = parts.slice(1).join(',').trim();
    
    // İlk kısım adres adı gibi görünüyor mu?
    const hasAddressMarker = addressMarkers.some(marker => 
      firstPart.toLowerCase().includes(marker.toLowerCase())
    );
    
    if (hasAddressMarker || firstPart.length <= 50) {
      return {
        name: firstPart,
        detail: restParts
      };
    }
  }
  
  // Virgül yoksa veya ayırma başarısız olduysa
  // İlk 40 karakteri adres adı olarak al
  if (fullAddress.length > 40) {
    const spaceIndex = fullAddress.indexOf(' ', 35);
    if (spaceIndex > 0 && spaceIndex < 60) {
      return {
        name: fullAddress.substring(0, spaceIndex),
        detail: fullAddress.substring(spaceIndex + 1)
      };
    }
  }
  
  // Çok kısa adres - tamamını adres adı olarak göster
  return {
    name: fullAddress,
    detail: ''
  };
};

export const AddressDisplay = ({ address, className = '' }) => {
  const { name, detail } = formatAddress(address);
  
  return (
    <div className={className}>
      {name && (
        <div className="font-semibold text-gray-900 leading-tight">
          {name}
        </div>
      )}
      {detail && (
        <div className="text-xs text-gray-500 mt-1 leading-relaxed">
          {detail}
        </div>
      )}
    </div>
  );
};
